var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_3281)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.0541,
    y1: 20.9459,
    x2: 20.9459,
    y2: 20.9459,
    strokeWidth: 2.10819,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_106_3281",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6773 2.53702C16.4584 1.75597 17.7247 1.75597 18.5058 2.53702L21.3844 5.41561C22.1654 6.19666 22.1654 7.46299 21.3844 8.24404L8.18772 21.4407L3.06739 21.9477C2.43942 22.0098 1.91155 21.482 1.97373 20.854L2.4807 15.7337L15.6773 2.53702Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.18772 21.4407L8.38478 23.4309L9.09633 23.3605L9.60193 22.8549L8.18772 21.4407ZM2.4807 15.7337L1.06649 14.3194L0.560882 14.825L0.49043 15.5366L2.4807 15.7337ZM3.06739 21.9477L2.87033 19.9574L3.06739 21.9477ZM17.0916 3.95123L19.9701 6.82982L22.7986 4.00139L19.92 1.1228L17.0916 3.95123ZM19.9701 6.82982L6.7735 20.0265L9.60193 22.8549L22.7986 9.65825L19.9701 6.82982ZM3.89491 17.1479L17.0916 3.95123L14.2631 1.1228L1.06649 14.3194L3.89491 17.1479ZM7.99066 19.4504L2.87033 19.9574L3.26445 23.9379L8.38478 23.4309L7.99066 19.4504ZM3.96399 21.051L4.47097 15.9307L0.49043 15.5366L-0.0165429 20.6569L3.96399 21.051ZM2.87033 19.9574C3.4983 19.8952 4.02617 20.4231 3.96399 21.051L-0.0165429 20.6569C-0.203072 22.5408 1.38054 24.1244 3.26445 23.9379L2.87033 19.9574ZM19.9701 6.82982L19.9701 6.82982L22.7986 9.65825C24.3607 8.09615 24.3607 5.56349 22.7986 4.00139L19.9701 6.82982ZM19.92 1.1228C18.3579 -0.439297 15.8252 -0.43929 14.2631 1.1228L17.0916 3.95123L17.0916 3.95123L19.92 1.1228Z",
    fill: "currentColor",
    mask: "url(#path-2-inside-1_106_3281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_3281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
export default SvgEdit;